const bindsToAddresses = (binds, getState) => {
	const addresses = getState().votingStore.addresses.addresses;
	const houses = {};
	binds.forEach((bind) => {
		if (bind.houseId) {
			houses[bind.houseId] = true;
		}
		if (bind.streetId) {
			addresses.forEach((company) => {
				if (company.companyId === bind.serviceCompanyId) {
					company.regions.forEach((region) => {
						region.streets.forEach((street) => {
							if (bind.streetId === street.streetId) {
								street.houses.forEach((house) => {
									houses[house.houseId] = true;
								});
							}
						});
					});
				}
			});
		}
		if (bind.regionId) {
			addresses.forEach((company) => {
				if (company.companyId === bind.serviceCompanyId) {
					company.regions.forEach((region) => {
						if (region.regionId === bind.regionId) {
							region.streets.forEach((street) => {
								street.houses.forEach((house) => {
									houses[house.houseId] = true;
								});
							});
						}
					});
				}
			});
		}
		if (!bind.regionId && !bind.streetId && !bind.houseId) {
			addresses.forEach((company) => {
				if (company.companyId === bind.serviceCompanyId) {
					company.regions.forEach((region) => {
						region.streets.forEach((street) => {
							street.houses.forEach((house) => {
								houses[house.houseId] = true;
							});
						});
					});
				}
			});
		}
	});
	return houses;
};

export default bindsToAddresses;
